import script from "./SurveyAuditCommittee.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyAuditCommittee.vue?vue&type=script&setup=true&lang=js"

import "./SurveyAuditCommittee.vue?vue&type=style&index=0&id=0c505cca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c505cca"]])

export default __exports__